import { useState } from "react";
import {platformAPI} from "../../../api/axiosConfig";
import {PaginatedResponseV2} from "../../../types/PaginatedResponse";
import {HotlineNumber} from "../typedefs";
import {useQuery} from "react-query";
import useDebouncer from "../../../hooks/debouncer";

export async function fetchNumbers(page: number, limit: number, search: string) {

    const res = await platformAPI.get<PaginatedResponseV2<HotlineNumber>>("api/hotline-numbers", {
        params: { page, limit, search },
    })

    return res.data

}

export async function fetchAvailableNumbers(page: number, limit: number, search: string, startTime: string, endTime: string) {

    const res = await platformAPI.get<PaginatedResponseV2<HotlineNumber>>("api/hotline-numbers/available", {
        params: { page, limit, search, startTime, endTime },
    })

    return res.data

}


export function useGetNumbers(initialSearch = "", initialPage = 1) {
    const [page, setPage] = useState(initialPage);
    const [limit, setLimit] = useState(20);
    const [search, setSearch] = useState(initialSearch);

    const debouncedSearch = useDebouncer(search, 300);

    const {data, isLoading, error, refetch} = useQuery(
        ["hotline-numbers", page, limit, debouncedSearch],
        () => fetchNumbers(page, limit, debouncedSearch),
        {
            enabled: true,
            cacheTime: 0,
            refetchOnMount: true,
        }
    );

    return {
        page, setPage,
        limit, setLimit,
        search, setSearch,
        data,
        isLoading,
        error,
        refetch
    }

}
